import React from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";

import * as Constants from "../../../../constants/Constants";

const DBMApprovalModal = ({ 
  onModalClose, 
  onSubmit, 
  show, 
  approveBtnDisabled,
  approvalErrorMsg 
}) => {
  return (
    <Modal
        show={show}
        onHide={() => onModalClose()}
        backdrop="static"
        size="lg"
        className="mt-5"
      >
        <Modal.Header closeButton>
            <Modal.Title className="text-center text-uppercase w-100">{Constants.DBM_APPROVAL_MODAL_TITLE}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5">
          {approvalErrorMsg && (
            <Row className="py-0">
              <Col className="px-4">
                <p className="text-center errorMessage w-100 mb-0">
                  {approvalErrorMsg}
                </p>
              </Col>
            </Row>
          )}
          <Row className="px-5 mx-5 my-5">
            <p className="text-center w-100 mb-0">
                {Constants.DBM_APPROVAL_MODAL_BODY_TEXT}
            </p>
            <p className="text-center w-100 mb-0">
                {Constants.DBM_APPROVAL_MODAL_BODY_QUESTION}
            </p>
          </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button
                className="button-later-md"
                onClick={() => onModalClose()}
            >
                {Constants.DBM_APPROVAL_MODAL_BUTTON_CANCEL}
            </Button>
            <Button
                className="button-primary-md"
                onClick={() => onSubmit()}
                disabled={approveBtnDisabled}
            >
                {Constants.DBM_APPROVAL_MODAL_BUTTON_YES}
            </Button>
        </Modal.Footer>
      </Modal>
  );
};
export default DBMApprovalModal;
